module.exports = __webpack_public_path__ + "static/media/newSongActive.a3b91e6b.svg";